import { removeHtmlTags } from '@spotahome/ui-library/src/tenant/components/utils/stringUtils';

import { howToBookItems } from './howToBookItems';

export const getJsonLdHowToBook = trans => {
  const steps = howToBookItems.map(item => {
    const stepLines = [];
    const itemListElement = [];

    item.pointKeys.forEach(point => {
      const mainText = [removeHtmlTags(trans(point.textKey))];

      if (point.subpointKeys && point.subpointKeys.length > 0) {
        point.subpointKeys.forEach(sub => {
          const subText = removeHtmlTags(trans(sub));
          stepLines.push(`- ${subText}`);
          mainText.push(`- ${subText}`);
        });
      }

      stepLines.push(mainText);
      itemListElement.push({
        '@type': 'HowToDirection',
        text: mainText.join(' ').trim()
      });
    });

    return {
      '@type': 'HowToStep',
      name: trans(item.titleKey),
      text: stepLines.join('\n').trim(),
      itemListElement
    };
  });

  return {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: trans('listing.how-to-book.section-main-title'),
    description: '',
    step: steps
  };
};

export default {
  getJsonLdHowToBook
};
